import { useServices } from 'containers/services';
import type { GetLicensesArg, GetLicensesStatisticsResponse } from 'lib/services';
import { type UseQueryResult, useQuery } from 'react-query';
import { QUERY_KEYS } from 'utils/queryKeys';
import { useAppNotifications } from 'hooks';

export const useLicenses = (filter?: GetLicensesArg): UseQueryResult<GetLicensesStatisticsResponse> => {
  const {
    backendGateway: { customersApiClient },
  } = useServices();
  const notify = useAppNotifications();

  return useQuery(
    QUERY_KEYS.customers.licenses(filter),
    async () => await customersApiClient.getLicensesStatistics(filter),
    {
      onError: error =>
        notify.error({
          type: 'error',
          message: 'There was an error while fetching licenses data',
          description: error instanceof Error ? error.message : undefined,
        }),
    },
  );
};
